/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as DeliveryTokenRouteImport } from './routes/delivery.$token'
import { Route as AppSessionSlugRouteImport } from './routes/_app.session.$slug'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const DeliveryTokenRoute = DeliveryTokenRouteImport.update({
  id: '/delivery/$token',
  path: '/delivery/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSessionSlugRoute = AppSessionSlugRouteImport.update({
  id: '/session/$slug',
  path: '/session/$slug',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/delivery/$token': typeof DeliveryTokenRoute
  '/session/$slug': typeof AppSessionSlugRoute
}
export interface FileRoutesByTo {
  '/delivery/$token': typeof DeliveryTokenRoute
  '/': typeof AppIndexRoute
  '/session/$slug': typeof AppSessionSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/delivery/$token': typeof DeliveryTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/session/$slug': typeof AppSessionSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/delivery/$token' | '/session/$slug'
  fileRoutesByTo: FileRoutesByTo
  to: '/delivery/$token' | '/' | '/session/$slug'
  id:
    | '__root__'
    | '/_app'
    | '/delivery/$token'
    | '/_app/'
    | '/_app/session/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DeliveryTokenRoute: typeof DeliveryTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/delivery/$token': {
      id: '/delivery/$token'
      path: '/delivery/$token'
      fullPath: '/delivery/$token'
      preLoaderRoute: typeof DeliveryTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/session/$slug': {
      id: '/_app/session/$slug'
      path: '/session/$slug'
      fullPath: '/session/$slug'
      preLoaderRoute: typeof AppSessionSlugRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppSessionSlugRoute: typeof AppSessionSlugRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppSessionSlugRoute: AppSessionSlugRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DeliveryTokenRoute: DeliveryTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
